
    var riot = require('riot')
    riot.tag2('header-tpl-quiz01', '<header class="{opts.current == \'top\' ? \'header_top\' : \'\'}"> <div class="header_inner"> <h1 class="logo" show="{opts.current != \'top\'}"> <img src="../images/quiz/logo.png" alt="進撃の巨人 in HITA"> </h1> <div class="lang_wrap" show="{opts.current == \'top\'}"> <div class="lang"><p>LANGUAGE</p></div> <ul> <li onclick="{lang_ja}">日本語</li> <li onclick="{lang_en}">ENGLISH</li> <li onclick="{lang_kr}">한국어</li> <li onclick="{lang_zh}">繁体中文</li> </ul> </div> </div> </header>', '', '', function(opts) {
    const glot = require('../src/scripts/modules/lang.js');

    this.open = function() {
      $('body').toggleClass('open');
      var lang = localStorage.getItem('lang');
      if(lang === 'ja') {
        $('.gnav').removeClass('less');
        $('.lang_en_hide').show();
        $('.lang_en_show').hide();
      } else {
        $('.gnav').addClass('less');
        $('.lang_en_hide').hide();
        $('.lang_en_show').show();
      };
    }.bind(this);

    this.lang_ja = function() {
      glot.render('ja');
      localStorage.setItem('lang','ja');
      $('.gnav').removeClass('less');
      $('.lang_en_hide').show();
      $('.lang_en_show').hide();
      $('.lang_kr_show').hide();
    }.bind(this)
    this.lang_en = function() {
      glot.render('en');
      localStorage.setItem('lang','en');
      $('.gnav').addClass('less');
      $('.lang_en_hide').hide();
      $('.lang_en_show').show();
      $('.lang_kr_show').hide();
    }.bind(this)
    this.lang_kr = function() {
      glot.render('kr');
      localStorage.setItem('lang','kr');
      $('.gnav').addClass('less');
      $('.lang_en_hide').hide();
      $('.lang_en_show').hide();

    }.bind(this)
    this.lang_zh = function() {
      glot.render('zh');
      localStorage.setItem('lang','zh');
      $('.gnav').addClass('less');
      $('.lang_en_hide').hide();
      $('.lang_en_show').hide();
      $('.lang_kr_show').hide();
    }.bind(this)
});

    
  